import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { RestaurantMenu } from './restaurant-menu';

export default createApp(
  { alias: meta.appAlias, name: meta.appName },
  RestaurantMenu
);
